import React from 'react';
import styled from 'styled-components';

export interface FileListPreviewProps {
  files: File[];
}

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]};
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
  width: 100%;
  padding: ${({ theme }) => theme.spacing[2]};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: #fff3e0;
`;

const FileGlyph = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #f86400;
  font-size: 16px;
  flex-shrink: 0;
`;

const FileName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`;

export const FileListPreview: React.FC<FileListPreviewProps> = ({ files }) => {
  if (!files || files.length === 0) {
    return null;
  }

  return (
    <List>
      {files.map((file, index) => (
        <Item key={`${file.name}-${index}`}>
          <FileGlyph aria-hidden="true">~</FileGlyph>
          <FileName title={file.name}>{file.name}</FileName>
        </Item>
      ))}
    </List>
  );
};